export const parseVariantsFromTags = (tags = [], parseDups) => {
  let materials = []
  let thicknesses = []

  tags.forEach(i => {
    if (i.startsWith('variant')) {
      const pieces = i.split('_')
      if (pieces[1] === 'thickness') {
        thicknesses.push(pieces[pieces.length - 1])
      } else {
        const variantOfVariant = pieces[1].split('-')

        if (parseDups && variantOfVariant[0] !== 'rose') {
          !materials.includes(variantOfVariant[1]) &&
            materials.push(pieces[pieces.length - 1])
        } else {
          materials.push(pieces[pieces.length - 1])
        }
      }
    }
    if (i.startsWith('material')) {
      const pieces = i.split('_')
      const variantOfVariant = pieces[1].split('-')

      if (parseDups && variantOfVariant[0] !== 'rose') {
        !materials.includes(variantOfVariant[1]) &&
          materials.push(pieces[pieces.length - 1])
      } else {
        materials.push(pieces[pieces.length - 1])
      }
    }
    if (i.startsWith('thickness')) {
      const pieces = i.split('_')
      const variantOfVariant = pieces[1].split('-')

      thicknesses.push(pieces[pieces.length - 1])
    }
  })

  return {
    materials,
    thicknesses,
  }
}
